import { render } from "./WorkbenchCard.vue?vue&type=template&id=4ccbc666&scoped=true"
import script from "./WorkbenchCard.vue?vue&type=script&lang=js"
export * from "./WorkbenchCard.vue?vue&type=script&lang=js"

import "./WorkbenchCard.vue?vue&type=style&index=0&id=4ccbc666&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ccbc666"]])

export default __exports__